export const SIGNAL_TYPES = {
    VISITOR_ADOPTION: 'visitor_adoption',
};
